import { FC, useState } from 'react'
import { Panel, PanelGroup } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import AttributeTitle from './AttributeTitle'
import { FeatureType } from '../../../utils/types/Product'
import { getFeatureTypeValueString } from '../../../lib/product'

import styles from '../../../styles/AttributeList.module.less'

interface FeaturesListProps {
  features: FeatureType[]
}

const FeaturesList: FC<FeaturesListProps> = (props) => {
  const { features } = props

  const { t } = useTranslation('features')
  const [activeTab, setActiveTab] = useState(1)

  const onActivatedTab = (tabId: number) => ((tabId === activeTab)
    ? setActiveTab(0)
    : setActiveTab(tabId))

  const renderFeatures = (attributeData: FeatureType[]) => attributeData?.map(
    (
      item: FeatureType,
      index,
    ) => {
      const isExpandable = item.text.length > 0
      const currentTabId = isExpandable ? activeTab : 0
      const eventKey = isExpandable ? index + 1 : 0
      const value = getFeatureTypeValueString(item)
      const headerText = value ? `${t(item.label)} · ${value}` : ''
      const description = Array.isArray(item.text)
        ? item.text.map((text) => <p key={text}>{text}</p>)
        : <p>{item.text}</p>

      return (
        !!headerText && (
          <Panel
            as="li"
            key={item.code}
            expanded={isExpandable ? currentTabId === eventKey : false}
            bordered={false}
            header={(
              <AttributeTitle
                eventKey={eventKey}
                tabId={currentTabId}
                isExpandable={isExpandable}
                text={headerText}
              />
            )}
            eventKey={index + 1}
          >
            <div className="product-attribute-description margin-top-spacer-half">{description}</div>
          </Panel>
        )
      )
    },
  )

  const noFeaturesText = t('products:Feature types are not defined')

  return (
    <PanelGroup
      as="ul"
      className={styles['product-attribute-list']}
      accordion
      bordered={false}
      defaultActiveKey={1}
      onSelect={(tabId) => onActivatedTab(Number(tabId))}
    >
      {features.length ? renderFeatures(features) : noFeaturesText}
    </PanelGroup>
  )
}

export default FeaturesList
